// Page-number list for pagination controls, with '...' gaps for long ranges.
// Shared by every paginated list (was copy-pasted in applications-ui, hub and admin).

export type PageItem = number | '...';

// Up to 7 pages: all of them. Otherwise: first, last, and a window of ±1 around the
// current page, with '...' where pages are skipped. `current` and `total` are 1-based.
export function getPageNumbers(current: number, total: number): PageItem[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages: PageItem[] = [1];
  if (current > 3) pages.push('...');

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) pages.push(i);

  if (current < total - 2) pages.push('...');
  pages.push(total);

  return pages;
}
